import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import {
  CustomerReturnRequestListDto,
  CustomerReturnRequestService,
} from '@digiwall/goliath-documents/proxy';
import {
  DwGridDataSourceService,
  FieldTypes,
  IEnumerationCellRendererParams,
} from '@digiwall/ag-grid';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { ColDef } from '@ag-grid-community/core';
import { BaseCustomerDocList } from '../../base-customer-docs/base-customer-doc-list';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';

@Component({
  selector: 'document-customer-return-request-list',
  templateUrl: './customer-return-request-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class CustomerReturnRequestListComponent
  extends BaseCustomerDocList<CustomerReturnRequestListDto, CustomerReturnRequestService>
  implements OnInit {
  override colDefs: ColDef[] = [
    ...this.colDefs,
    {
      field: 'customerReturnRequestStatus',
      headerName: this.localizationService.instant(
        'Doc::CustomerReturnRequest:CustomerReturnRequestStatus',
      ),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.documentEnumerationTypeStore.customerReturnRequestStatus,
      } as IEnumerationCellRendererParams,
    },
  ];

  private _columns: ColDef[] = [...this.colDefs];

  get columns(): ColDef[] {
    return this._columns;
  }

  constructor(
    customerReturnRequest: CustomerReturnRequestService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      customerReturnRequest,
      router,
      route,
      localizationService,
      subscriptionService,
      confirmation,
      datasource,
      injector,
    );

    this.applyDefaultColumnVisibility();
    this.showColumns('description');
    this._columns = this.orderColumns(this._columns, [
      'displayNumber',
      'documentDate',
      'isClosed',
      'thirdPartyCode',
      'thirdPartyName',
      'reference',
      'description',
      'totalAmount',
      'customerReturnRequestStatus',
    ]);
    this.applyColumnWidths(
      {
        displayNumber: 110,
        documentDate: 150,
        isClosed: 110,
        thirdPartyCode: 150,
        thirdPartyName: 200,
        totalAmount: 150,
        customerReturnRequestStatus: 110,
      },
      ['reference', 'description'],
      180,
    );
  }
}
